const SKU_LIMIT = 50;

export default {
  SKU_LIMIT,
};
